'use strict';

var CellRendererService = function CellRendererService() {
  function marketCellRenderer(params) {
    var isNew = '';
    if (params.data.isNew) {
      isNew += '<span class="new-market">New</span>';
    }
    return isNew + ' <span>' + params.value + '</span>';
  }
  function numberInputCellRenderer(options, params) {
    return '<input class="rm-ag-grid-input" type="number" pattern="^[0-9]+(\.[0-9]+)*?$"' + 'min="' + options.min + '" max="' + options.max + '" ' + 'ng-model="' + options.model + '[' + params.rowIndex + '].' + params.colDef.field + '"/>';
  }
  function integerInputCellRenderer(options, params) {
    if (options.tooltip) {
      return '<form xt-form strategy="submittedOrTouched"><input ' + 'xt-validation-tooltip validate="true" placement="top" container="' + options.tooltip.container + '" class="rm-ag-grid-input" type="number" pattern="^[0-9]+?$"' + 'min="' + options.min + '" max="' + options.max + '" ' + 'ng-model="' + options.model + '[' + params.rowIndex + '].' + params.colDef.field + '" ' + options.tooltip.settings + '/></form>';
    } else {
      return '<input class="rm-ag-grid-input" type="number" pattern="^[0-9]+?$"' + 'min="' + options.min + '" max="' + options.max + '" ' + 'ng-model="' + options.model + '[' + params.rowIndex + '].' + params.colDef.field + '"/>';
    }
  }
  function assigneeInputCellRenderer(options, params) {
    if (options.isUserAdmin) {
      return '<rm-combobox item-list="userIdList" type-ahead="true" ' + 'fixed-position="true" ' + 'ng-model="scheduleChange.significantManagedEntities[' + params.data.marketIndex + '].ownerDisplayName"></rm-combobox>';
    }
    if (!options.model.significantManagedEntities[params.data.marketIndex].owner) {
      options.model.significantManagedEntities[params.data.marketIndex].ownerDisplayName = options.currentUser.getDisplayName();
      options.model.significantManagedEntities[params.data.marketIndex].owner = options.currentUser.getUserId();
    }
    return '<span>' + options.model.significantManagedEntities[params.data.marketIndex].ownerDisplayName + '</span>';
  }
  function assigneeLegInputCellRenderer(options, params) {
    if (options.isUserAdmin) {
      return '<rm-combobox item-list="userIdList" type-ahead="true" ' + 'fixed-position="true" ' + 'ng-model="scheduleChange.significantManagedEntities[' + params.rowIndex + '].ownerDisplayName"></rm-combobox>';
    }
    if (!options.model.significantManagedEntities[params.rowIndex].owner) {
      options.model.significantManagedEntities[params.rowIndex].ownerDisplayName = options.currentUser.getDisplayName();
      options.model.significantManagedEntities[params.rowIndex].owner = options.currentUser.getUserId();
    }
    return '<span>' + options.model.significantManagedEntities[params.rowIndex].ownerDisplayName + '</span>';
  }
  function spanCellRenderer(params) {
    return '<span>' + params.value + '</span>';
  }
  return {
    marketCellRenderer: marketCellRenderer,
    //textInputCellRenderer: textInputCellRenderer,
    numberInputCellRenderer: numberInputCellRenderer,
    integerInputCellRenderer: integerInputCellRenderer,
    assigneeInputCellRenderer: assigneeInputCellRenderer,
    spanCellRenderer: spanCellRenderer,
    assigneeLegInputCellRenderer: assigneeLegInputCellRenderer
  };
};
CellRendererService.$inject = [];
module.exports = CellRendererService;